// components/PlaybackStatusMessage.tsx
import React, { useEffect, useState } from 'react';

interface PlaybackStatusMessageProps {
  status: string | null;
}

const PlaybackStatusMessage: React.FC<PlaybackStatusMessageProps> = ({ status }) => {
  const [countdown, setCountdown] = useState<number | null>(null);

  useEffect(() => {
    // If status contains "Opening Spotify", start a countdown
    if (status?.includes('Opening Spotify')) {
      setCountdown(5);
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev === null || prev <= 1) {
            clearInterval(timer);
            return null;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    } else {
      setCountdown(null);
    }
  }, [status]);

  if (!status) return null;

  const isError = status.startsWith('Error');
  const isSpotifyOpening = status.includes('Opening Spotify');

  return (
      <div
          className={`mt-3 p-2 rounded-md ${
              isError ? 'bg-red-100 text-red-700' :
                  isSpotifyOpening ? 'bg-yellow-100 text-yellow-800' :
                      'bg-blue-100 text-blue-700'
          }`}
      >
        {status}
        {countdown && (
            <div className="mt-1 text-sm">
              Retrying playback in {countdown} seconds...
            </div>
        )}
        {isSpotifyOpening && (
            <div className="text-sm mt-1">
              If Spotify doesn't open automatically, please open it manually and try again.
            </div>
        )}
      </div>
  );
};

export default PlaybackStatusMessage;
